import { getApplicationContext, reportEvents, ReportGenerationSucceededEventArgs, UIViewEventArgs, uiViewEvents } from '@neos/core'
import { getDefaultValueByType } from '@neos/shared'
import { uiCustomizationOnLayoutUpdatedAsync } from '@src/sharedMethods/uiCustomization'
import { isHybridApp } from '@neos/hybrid-app'
import { userPermissionsOnReportGenerationSucceededAsync } from '@src/sharedMethods/userPermissions'

/**
 * On UI customization init.
 */
export function appInitializationOnUICustomizationInit(): void {
  if (getApplicationContext('IsanetCMSMobile').getValue('UserCustomViewMode', getDefaultValueByType('string') as string) == 'Auto') {
    uiViewEvents.layoutUpdated.add((args) => uiCustomizationOnLayoutUpdatedAsync(args));
  }
}

/**
 * On user permissions init.
 */
export function appInitializationOnUserPermissionsInit(): void {
  if (isHybridApp()) {
    reportEvents.generationSucceeded.add((args) => userPermissionsOnReportGenerationSucceededAsync(args));
  }
}
